import { render, staticRenderFns } from "./UserSecurityActiveFa.vue?vue&type=template&id=7148c5a1&scoped=true&"
import script from "./UserSecurityActiveFa.vue?vue&type=script&lang=js&"
export * from "./UserSecurityActiveFa.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityActiveFa.vue?vue&type=style&index=0&id=7148c5a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148c5a1",
  null
  
)

export default component.exports